/* @flow */

export const tokenCookieParam = 'token';
export const cidCookieParam = 'cid';
export const localeCookieParam = 'locale';
export const onboardingCookieParam = 'onboarding_completed';
